module.exports = __webpack_public_path__ + "img/oppo-ax7.36249bca.jpg";